import { Injectable, inject } from '@angular/core';
import { MatSnackBarRef, MatSnackBar } from '@angular/material/snack-bar';
import { ApiGatewayService, API_GATEWAY_CONFIG, ApiGatewayConfig, EcaSnackbarAlertComponent, EcaSnackbarAlertConfig } from '@drc-eca/eca-components-lib';
import { Observable, of } from 'rxjs';
import { SearchCriteria, SortService } from '../../util/sort.service';
import { IStatusType } from '../../model/common.model';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ClientStatusService {
  config = inject<ApiGatewayConfig>(API_GATEWAY_CONFIG, { optional: true })!;
  private apiGatewaySvc = inject(ApiGatewayService);
  private http = inject(HttpClient);
  private sortService = inject(SortService);
  private snackBar = inject(MatSnackBar);

  constructor() {}

  getServiceName () {
   return `${this.config['lambdaServiceUrl']}`;
  }

  doGet(path: string, options: any = {}) {
    const opts = this.getOptions();
    
    // For public endpoints (no token), use HttpClient directly to bypass ECA auth interceptors
    if (!opts.includeToken) {
      return this.http.get(`${this.getServiceName()}/${path}${options.query? options.query : ''}`);
    }
    
    return this.apiGatewaySvc.get(`${this.getServiceName()}/${path}${options.query? options.query : ''}`, opts);
  }

  doPost (path: string, data: any) {    
    return this.apiGatewaySvc.post(`${this.getServiceName()}/${path}`, data, this.getOptions());
  }

  doPut (path: string, data: any) {    
    return this.apiGatewaySvc.put(`${this.getServiceName()}/${path}`, data, this.getOptions());
  }

  doDelete (path: string, id: string) {
    return this.apiGatewaySvc.delete(`${this.getServiceName()}/${path}/${id}`, this.getOptions());
  }

  getServiceStatusList(): Observable<IStatusType[]>{
    //return ['Normal Operations', 'Degraded Performance', 'Partial Outage', 'Major Outage', 'Maintenance' ];
    return this.apiGatewaySvc.get(`${this.getServiceName()}/admin/status`, this.getOptions());
  }

  getServiceStateList(){
    return ['Investigating', 'Identified', 'Monitoring', 'Resolved'];
  } 

  getClass = (name: string) => {
    switch (name) {
      case 'Normal Operations': {
        return 'operational';
      }
      case 'Partial Outage': {
        return 'partialoutage';
      }
      case 'Investigating':{
        return 'majoroutage';
      }
      case 'Identified':{
        return 'partialoutage';
      }
      case 'Monitoring':{
        return 'monitoring';
      }
      case 'Resolved':{
        return 'resolved';
      }
      case 'Major Outage':{
        return 'majoroutage';
      }
      default : {
        return 'degraded';
      }
    }
  }

  private getOptions(){     
    // Only include token if user is authenticated and token is valid (not null/empty)
    const token = sessionStorage.getItem('ngStorage-ecatoken');
    const hasToken = token != null && token !== 'null' && token !== '';
    
    let options: any = {
      httpOptions : {
        headers : {
          'authsource': sessionStorage.getItem('localSecurityOn') === 'true' ? 'local' : 'eca-security-service'
        }
      },
      includeToken: hasToken,
      withCredentials: false
    };

    return options;
  }

  sortArray(data:any[], sortColumn: string, sortDirection = 'asc'){
    let criteria: SearchCriteria = new SearchCriteria();
    criteria.sortColumn = sortColumn;
    criteria.sortDirection = sortDirection;
    return this.sortService.sort(criteria, data);
  }

  openGoodSnackBar(inMessage: string, snackBarRef: MatSnackBarRef<EcaSnackbarAlertComponent>) {
    snackBarRef = this.snackBar.openFromComponent(EcaSnackbarAlertComponent, {
      duration: 5000,
      panelClass: 'mat-snack-positive',
      verticalPosition: 'top',
      data: {
        icon: 'check_circle',
        message: inMessage
      }
    });
  }

  openBadSnackBar(inMessage: string, error: any = null) {
    const config = new EcaSnackbarAlertConfig(`${inMessage} ${error != null? error:''}`, 'negative');
    this.snackBar.openFromComponent(EcaSnackbarAlertComponent, config);
  }


}

